import { useQuery, useQueryClient } from '@tanstack/react-query'

import { QueryKeys } from '@/app/_utils/react-query'

const getInitialSeenIds = (): Set<string | number> => {
    return new Set()
}

export const useSearchImpression = () => {
    const queryClient = useQueryClient()

    const { data: seenIds = new Set() } = useQuery<Set<string | number>>({
        queryKey: QueryKeys.Layout.SearchImpressionSeenIds,
        queryFn: () => getInitialSeenIds(),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    })

    const markAsSeen = (id: string | number | undefined) => {
        if (!id) return

        queryClient.setQueryData<Set<string | number>>(QueryKeys.Layout.SearchImpressionSeenIds, (old) => {
            const newSet = old ? new Set<string | number>(old) : new Set<string | number>()
            newSet.add(id)
            return newSet
        })
    }

    const resetImpressions = () => {
        queryClient.setQueryData<Set<string | number>>(QueryKeys.Layout.SearchImpressionSeenIds, new Set())
    }

    return {
        seenIds,
        markAsSeen,
        resetImpressions,
    }
}
